import { useTreatment } from '@splitsoftware/splitio-react'
import PropTypes from 'prop-types'
import { useSeller } from '@/contexts/seller'

const SplitControl = ({
  splitName,
  attributes = {},
  treatmentOff,
  loading,
  children,
}) => {
  const { sellerData } = useSeller()

  const pocId =
    sellerData?.seller?.id ??
    JSON.parse(localStorage.getItem('SELLER_DATA'))?.seller?.id

  const { treatment, isReady } = useTreatment({
    name: splitName,
    attributes: { poc_id: pocId, ...attributes },
    splitKey: process.env.SPLIT_IO_KEY,
  })

  if (!isReady) return loading ?? null

  return treatment === 'on' ? children : (treatmentOff ?? null)
}

SplitControl.propTypes = {
  splitName: PropTypes.string.isRequired,
  treatmentOff: PropTypes.node,
  loading: PropTypes.node,
  children: PropTypes.node.isRequired,
  attributes: PropTypes.object,
}

export default SplitControl
